module.exports = __webpack_public_path__ + "is.d8081da0e73782eaa550.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/is.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/is.svg
// module chunks = styles